var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10991",
    "data-name": "Group 10991",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_card",
    "data-name": "vuesax/bold/card",
    transform: "translate(-357.902 -98.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(492 508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5,3.424a.993.993,0,0,1-.99.99H.99A.993.993,0,0,1,0,3.424V3.416A3.412,3.412,0,0,1,3.416,0h9.663A3.426,3.426,0,0,1,16.5,3.424Z",
    transform: "translate(1.65 2.806)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,.99V5.124A3.412,3.412,0,0,0,3.416,8.54h9.663A3.426,3.426,0,0,0,16.5,5.116V.99a.993.993,0,0,0-.99-.99H.99A.993.993,0,0,0,0,.99ZM4.951,5.776H3.3a.619.619,0,0,1,0-1.238h1.65a.619.619,0,0,1,0,1.238Zm5.364,0h-3.3a.619.619,0,0,1,0-1.238h3.3a.619.619,0,0,1,0,1.238Z",
    transform: "translate(1.65 8.458)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H19.8V19.8H0Z",
    fill: "none",
    opacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.1c36a404076d7d1f5672f0ccba3c0514.svg";
export { ForwardRef as ReactComponent };